import { notification as dispatchNotification } from "antd";

let timeout: NodeJS.Timeout;
export const toast = (
  message: string,
  type: "success" | "info" | "warning" | "error",
  options?: any
) => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    dispatchNotification.destroy();
    dispatchNotification[type]({ message, ...options });
  }, 100);
};

toast.success = (message: string, options?: any) =>
  toast(message, "success", options);

toast.info = (message: string, options?: any) =>
  toast(message, "info", options);

toast.warn = (message: string, options?: any) =>
  toast(message, "warning", options);

toast.error = (message: string, options?: any) =>
  toast(message, "error", options);
